


























export default {
  name: 'Devices',
};
